// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RelatedProductItem_wrapper__8pde0","name":"RelatedProductItem_name__2WM_2","price":"RelatedProductItem_price__baZrd","img-box":"RelatedProductItem_img-box__1QQA9"};